
function in_array(needle, haystack){
	for(var i = 0;i < haystack.length; i++){
		if(haystack[i] === needle){
			return true;
		}
	}
	return false;
}

window.Timetracking = {
	
	disabledDays : [],
	
	initDisabledDays : function(dayStart, dayStop){
		
		for(var cpt= dayStart; cpt<=dayStop; cpt++){
			Timetracking.disabledDays.push(cpt);
		}
		
		if(dayStart === 7 || dayStop === 7){
			Timetracking.disabledDays.push(0);
		}
	},
	
	loadPrefs : function(id, mode){
		
		var idEntry = undefined !== id ? id : '';
		var options = {
			title	: Loc.g("Préférences Timetracking"),
			width:600,
			buttons	: [
                {
                    text : Loc.g("Fermer"), 
                    class: 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
                {
                    text : Loc.g("Enregistrer"), 
                    class: 'btn btn-primary',
					click : function(){
						$('#prefsTtForm').submit();
					}
				}
			],
			callback	: function(){
				Timetracking.preparePrefsForm();
			}
		};
		
		MyWindow.load("timetracking_prefs", {action:""}, options);
		
	},
	
	preparePrefsForm : function(){
		
        var options = {
			data	: {
				action	: 'record'
			},
			success	: function(data){
				Timetracking.prefsFormCallback(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("prefsTtForm", "timetracking_prefs", options);
		
		$.mask.definitions['5']='[0-5]';
		$(".dayEntry").mask("99:59",{placeholder:"-", replacement : '0'});
		
		$('#prefs_useManDays').on('click', function(){
			
			if ($('#prefs_useManDays').is(':checked')){
				$('#nbMinADayContainer').show();
			} else {
				$('#nbMinADayContainer').hide();
			}
			
		});
		
		$('#prefs_useAlerts').on('click', function(){
			
			if ($('#prefs_useAlerts').is(':checked')){
				$('#useAlertsContainer').show();
				MyFacture.customForm();
			} else {
				$('#useAlertsContainer').hide();
			}
			
		});
		
		$('#prefs_ttOnAnnotationFor').multipleSelect({
			placeholder		: Loc.g("Choisissez des valeurs"),
			width			: 245,
			selectAll		: false,
			position		: 'bottom',
			countSelected	: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
		});
		
		MyFacture.customForm();
		
		
	},
	
	checkDays : function(){
		if($('#prefs_dayStart').val() >= $('#prefs_dayStop').val()){
			MyWindow.alert(Loc.g("Erreur d'enregistrement. Le jour de début ne peut pas être identique ou après le jour de fin."), {type: 'confirm'});
		}
	},
	
	prefsFormCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "prefsTtForm");
		
		if (formIsOk){
			MyWindow.close();
			var options = {
				type		: "confirm",
				buttons		: [
					{
						text : Loc.g("Ok"), 
						click : function(){ 
							Utils.reload();
						}
					}
				]
			};
			MyWindow.alert(Loc.g("Vos préférences ont été mémorisées"), options);
		} else {
			MyWindow.alert(Loc.g("Erreur d'enregistrement"), {type: 'error'});
		}
		
	},
	
	prepareFilterForm: function(){
		
        var options = {
			dataType:"json",
			data	: {
				action : 'updateListing'
			},
			success	:function(data){
				Timetracking.processFilterForm(data);
			} 
		};
		
        MyForm.prepare("timetrackingentriesFilterForm", "timetracking_listing", options);
		$('#facette-stats .nano').nanoScroller({preventPageScrolling: true});
		
		$('.ttstat-toggler').on('click', function(e){
			
			if ($(this).next().is(':visible')){
				
				$(this).next().slideUp('normal', function(){
					$('#facette-stats .nano').nanoScroller({preventPageScrolling: true});
				});
			} else {
				$('.ttstat-toggler').next(':visible').slideUp();
				
				$(this).next().slideDown('normal', function(){
					$('#facette-stats .nano').nanoScroller({preventPageScrolling: true});
				});
			}
		});
		
		Timetracking.initListiingGraph();
		
    },
	
	processFilterForm: function(data){
		
		Listing.refresh("timetrackingentriesListing", data, data.timetrackingentries_metadatas);		
		$('#facette-stats .nano').nanoScroller({preventPageScrolling: true});
		Timetracking.initListiingGraph();
		
	},
	
	initListiingGraph: function(){

		$('#timetrackingListingStats div[e_autograph]').each(function(){
			
			var json = $.parseJSON($(this).attr('graph_data'));
			var seriesData = [];
			
			$.each(json, function(index, value){
				seriesData.push([index, value]);
			});
			
			$(this).highcharts({
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: 0,
					plotShadow: false,
                    backgroundColor: "transparent"
				},
				title: {
					text: $(this).attr('graph_name'),
					align: 'center',
					verticalAlign: 'middle',
					y: 50
				},
				tooltip: {
                    useHTML: true,
					positioner: function () {
                        return { x: 0, y: 10 };
					},
					borderWidth: 0,
					shadow: false,
					formatter: function () {
						return '<div class="wide-tooltip">' + this.point.name + '<br>' + '<b>' + Loc.g('Représente') + ' ' +  Highcharts.numberFormat(this.point.percentage, 2) + '%</b></div>';
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: false
						},
						startAngle: -90,
						endAngle: 90,
						center: [
							'50%', 
							'75%'
						]
					}
				},
				credits: {
					enabled: false
				},
				series: [{
					type : 'pie',
					name : Loc.g('Représente'),
					innerSize: '50%',
					data : seriesData
 				}]
			});
		});
		
	},
	
	askUnlik: function(linkId){
		
		var msg =  Loc.g("Vous allez délier le temps du document, voulez-vous continuer");
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Delier un temps"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"), 
					click : function(){
						Timetracking.unlik(linkId);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msg, options);

	},
	
	unlik : function(linkId){	
		
		MyFacture.post(
			'timetracking_entries',
			{
				action	: 'unlinkOne',
				linkId	: linkId
			}, 
			function(data){
			
				if (data[0].status === "ok"){
					$('.link_'+linkId).remove();
					purchaseTools.initMarge();
					MyWindow.close();
				}
			}, 
			"json"
		);
	},
	
	isNotLinkable: function(errorMsg) {
		MyWindow.alert(errorMsg, {type: 'error'});
	},
			
	viewLinkedTimetracking : function(linkedid, linkedtype) {
		
		var options = {
			title	: Loc.g('Liste des entrées de timetracking liées'),
			width	: 600,
			buttons	: [
				{
					text	: Loc.g("Fermer"), 
					click	: function(){
						$(this).dialog("close");
					}
				}
			]
		};
		
		var fileOpt = {
			action		: "viewLinkedTimetracking", 
			linkedid	: linkedid, 
			linkedtype	: linkedtype
		};
		
		MyWindow.load("timetracking_entries", fileOpt, options);
		
	}

};

window.TimetrackingEntry = {
	
	massToggleBillable: function(rowSelection, billable){
		
		var title = Loc.g('Marquer comme refacturable');
		if (billable === 'N'){
			title = Loc.g('Marquer comme non refacturable');
		}
		
		var options = {
			title	: title,
			width	: 600,
			buttons	: [
                {
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$('#massToggleBillableForm').submit();
					}
				}
			],
			callback	: function(){
				
				var opts = {
					data : {
						action : 'massToggleBillableFormRecord'
					},
					
					success:function(data){
						Listing.update("timetrackingentriesListing");
						MyWindow.close();
					}, 
					dataType:"json"
				};
				
				
				MyForm.prepare("massToggleBillableForm", "timetracking_entries", opts);
			}
		};
		MyWindow.load("timetracking_entries", {action:"massToggleBillableForm", rowSelection:rowSelection, billable:billable}, options);
		
	},
	
	edit : function(id, linkedId, linkedType, callBack, thirdid, serviceid){
		var idEntry		= undefined !== id ? id : '';
		var linkedId	= undefined !== linkedId ? linkedId : '';
		var linkedType	= undefined !== linkedType ? linkedType : '';
		var callBack	= undefined !== callBack ? callBack : '';
		var thirdid		= undefined !== thirdid ? thirdid : '';
		var serviceid	= undefined !== serviceid ? serviceid : '';
		
		var buttons		= [
            {
				text : Loc.g("Annuler"), 
				'class': 'btn btn-default',				
				click : function(){
					$(this).dialog("close");
				}
			},
            {
				text : Loc.g("Enregistrer"),
				'class': 'btn btn-primary',				
				click : function(){
					$('#entryForm').submit();
				}
			}
		];
		
		if(idEntry !== '') {
			buttons		= [
                {
					text : Loc.g("Annuler"),
					'class': 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Supprimer"),
					'class': 'btn btn-primary',
					click : function(){
						TimetrackingEntry.doDelete(idEntry, 'reload');
					}
				},
                {
					text : Loc.g("Enregistrer"),
					'class': 'btn btn-primary',
					click : function(){
						$('#entryForm').submit();
					}
				}
			];
		}
		
		var options = {
			title		: Loc.g("Saisie rapide de Timetracking"),
			width		: 600,
			buttons		: buttons,
			callback	: function(){
				TimetrackingEntry.prepareForm(idEntry, callBack);
			}
		};
		MyWindow.load("timetracking_entries", {action:"entryForm", timeid:idEntry, linkedId:linkedId, linkedType:linkedType, thirdid:thirdid, serviceid:serviceid}, options);
		
	},
	
	addFromDoc : function(doctype, docid){
		
		var options = {
			dialogClass : "white",
			title	:  Loc.g("Saisie rapide"),
			width	: 600,
			buttons	: [
                {
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Enregistrer"), 
					click : function(){
						$('#entryForm').submit();
					}
				}
			],
			callback	: function(){
				TimetrackingEntry.prepareForm('00');
			}
		};
		MyWindow.load("timetracking_entries", {action:"entryForm", docid : docid, doctype:doctype}, options);
		
	},
	
	prepareForm : function(id, callBack){
		
		var callBack	= undefined !== callBack ? callBack : '';
		var format		= $("#entry_date").attr('format');
		var dateFormat	= "dd/mm/yy";

		switch (format) {
			case 'mdy':
				dateFormat = "mm/dd/yy";
				break;
		}
		
		if ($('#entry_billed').val() === "N"){
            var tokenSel = function(item){
                var more = item.id.replace(new RegExp('corporation_', 'g'), 'third_');
                if($("#entry_linked").length != 0){
                    $("#entry_linked").tokenInput('more', more);
                }
                $("#entry_ttLinkedElementlinked").tokenInput('more', more);
            };

            var tokenDel = function(){
                if($("#entry_linked").length != 0) {
                    $("#entry_linked").tokenInput('clear');
                    $("#entry_linked").tokenInput('more', '');
                }

                $("#entry_ttLinkedElementlinked").tokenInput('clear');
                $("#entry_ttLinkedElementlinked").tokenInput('more', '');
            };

            TokenInput.autoContactListing("#entry_thirdid", 'third|prospect', 1, true, '', tokenSel, tokenDel);

			var moreStart		= $('#entry_thirdid').tokenInput('get');
			var moreStartString = "";

			if (moreStart[0] !== undefined){
				moreStartString = moreStart[0].id.replace(new RegExp('corporation_', 'g'), 'third_');;
			}
			
			var autodoc = $("#entry_linked").data('autodoc');
			if ($("#entry_linked").length > 0){
				TokenInput.autoDocumentListing("#entry_linked", autodoc, 1, true, moreStartString, 
					function(item){
						var third = $("#entry_thirdid");
						if(third.tokenInput('get').length === 0) {
							$("#entry_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
						}
				}, '', 'timetracking');
			}

			TimetrackingEntry.initEntryFormTokeninputs(moreStartString);

            var firstDay = $("#entry_date").attr('firstDay');
            var lang = $("#entry_date").attr('lang');

            $.datepicker.setDefaults($.datepicker.regional[lang]);
			$("#entry_date").datepicker({
                changeMonth: true,
                changeYear: true,
				beforeShowDay: function(date) {
					var day = parseInt(date.getDay(), 10);
					if(Timetracking.disabledDays.length === 0){
						return [true];
					}else{
						return [Utils.in_array(day, Timetracking.disabledDays)];
					}
				},
                dateFormat : dateFormat,
                firstDay: firstDay
			});


			$('#entry_ttLinkedElementlinkedType').on('change', function() {
				
				var moreStart		= $('#entry_thirdid').tokenInput('get');
				var moreStartString = "";
				
				if (moreStart[0] !== undefined){
					moreStartString = moreStart[0].id.replace(new RegExp('corporation_', 'g'), 'third_');;
                }
				
				$('#entry_ttLinkedElementlinked').parent().find(".token-input-list").remove();
				$("#entry_ttLinkedElementlinked").tokenInput('clear');
				$('#__persistent__entry_ttLinkedElementlinked').remove();
				TimetrackingEntry.initEntryFormTokeninputs(moreStartString);
			});

			$.mask.definitions['5']='[0-5]';
			var inputEntryTime	= $("#entry_nbSecondes");
			var formatMask		= (inputEntryTime.attr('data-useprecisionseconde')) ? "99:59:59" : "99:59";
			
			inputEntryTime.mask(formatMask, {placeholder:"-", replacement : '0'});

			inputEntryTime.change(function(){
				
				var nbMin		= TimetrackingTools.hourMinSecToSec($(this).val());
				var nbMinADay	= parseInt($('#entry_manDayEntry').attr('nbMinADay'),10);
				var manDay		= TimetrackingTools.minToManDay(nbMin, nbMinADay);
				
				$('#entry_manDayEntry').val(manDay);
			});

			$('#entry_manDayEntry').change(function(){
				
				var rawNbManDays	= $(this).val().replace(',', '.');
				var nbManDays		= parseFloat(rawNbManDays,10);
				var nbMinADay		= parseInt($(this).attr('nbMinADay'),10);
				var nbMin			= TimetrackingTools.mandayToMin(nbManDays, nbMinADay);
				var hourMin			= TimetrackingTools.secToHourMinSec(nbMin);
				var hourMinString	= TimetrackingTools.formatTimeToString(hourMin, inputEntryTime.attr('data-useprecisionseconde'));
				
				$("#entry_nbSecondes").val(hourMinString);

			});
		}


		MyFacture.customForm("#entryForm");
        MyForm.prepare("entryForm", "timetracking_entries&action=recordEntry", { 
				success:function(data){
					TimetrackingEntry.recordCallback(data, callBack);
				}, 
				dataType:"json"
			}
		);
		
	},
	
	initEntryFormTokeninputs: function(moreStartString) {

        var linkedtype = $('#entry_ttLinkedElementlinkedType').val();
        
		switch (linkedtype){
			case "opportunity":
				
				TokenInput.autoOpportunity("#entry_ttLinkedElementlinked", function(item){
					var third = $("#entry_thirdid");
					if(third.tokenInput('get').length === 0) {
						$("#entry_thirdid").tokenInput('add', {id : item.linkedId, name: item.linkedName});
						var more = "third_" + item.linkedId;
						$("#entry_linked").tokenInput('more', more);
					}
				}, moreStartString, 1); 
				break;
				
			case "ticket":
				
				TokenInput.autoSupport('#entry_ttLinkedElementlinked', function(item) {
					var third = $("#entry_thirdid");
					if(third.tokenInput('get').length === 0) {
						$("#entry_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdName});
						var more = "third_" + item.thirdid;
						$("#entry_linked").tokenInput('more', more);
					}
				}, moreStartString, 1); 
				break;
            case 'projectEntry':
                moreStartString = 'onlyopen';
				TokenInput.autoProjectEntry('#entry_ttLinkedElementlinked', null, null, moreStartString);
				break;
		}
		
	},
	
	recordCallback : function(data, callBack){
		
		var formIsOk = MyForm.processJson(data, "entryForm");

		if(formIsOk){
			
			MyWindow.close();

            if (callBack !== ""){
                typeof callBack == 'function' ? callBack(data.ttLinkedElementDetails) : eval(callBack + '(data.ttLinkedElementDetails)');
                return;
			}
			
			const message = Loc.g("La sauvegarde a réussi !");
			Push.success(message);
			
			if ($('#timetrackingentriesListing_container').length > 0){
				Listing.update("timetrackingentriesListing");
			}
			//Si nous sommes sur la page de saisie hebdomdaire on reload la page pour la mettre à jour
			if ($("#timesheet").length > 0) {
				Utils.reload();
			}
		}
	},
	
	contactSelect : function(item){

		var more = item.id.replace(new RegExp('corporation_', 'g'), 'third_');
		
		if ($("#entry_linked").length > 0 ){
			$("#entry_linked").tokenInput('more', more);
			$("#entry_linked").trigger('blur');
		}
		
		$('#entry_ttLinkedElementlinkedType').trigger('change');
		
	},
	
	contactDelete : function(item){
		if ($("#entry_linked").length > 0) {
			$("#entry_linked").tokenInput('clear');
			$("#entry_linked").tokenInput('more', '');
			$("#entry_linked").trigger('blur');

		}
		
	},
	
	docSelect : function(item){
		
		$("#entry_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
		$("#entry_thirdid").trigger('blur');
		
	},
	
	
	confDelete : function(id){
		
		if(Utils.exists('delete-'+id)){
			$('#delete-'+id).show();
			MyFacture.customForm();
		}
		
	},
	
	cancelDelete : function(id){
		
		$('#delete-'+id).hide();
		
	},
	
	doDelete : function(id, callBack){

		if($('#staffCanDeleteEntries').length === 0 || $('#staffCanDeleteEntries').val() === 'Y'){

			var callBack = callBack === undefined ? '' : callBack;

			var options = {
				resizable	: false,
				noclose		: true,
				type		: "warning",
				title		: Loc.g("Suppression d'une heure"),
				buttons		: [
					{
						text : Loc.g("Annuler"), 
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Valider"),
						click : function(){
							
							var datas	= {action:"delete", timeid:id};
							var me		= $(this);
							
							MyFacture.post(
								"timetracking_entries", 
								{
									action	: "delete", 
									timeid	: id
								},
								function(data){
									
									if(data.error === undefined){
										me.dialog('close');
										TimetrackingEntry.deleteCallback(data);
										
										if (callBack !== ""){
											if(callBack === 'reload'){
												Utils.reload();
											}else{
												eval(callBack+"(data)");
											}
										}
									}
								}, 
								"json"
							);
						}
					}
				]
			};

			MyWindow.alert(Loc.g("Supprimer cette saisie d'heure?"), options);

		} else {

			MyWindow.alert(Loc.g("Vous n'avez pas le droit de supprimer une saisie d'heure")+".", {type: "error", title: Loc.g('Privilèges insuffisants') });

		}

	},

	deleteCallback : function(){

		var listingNames = [
			'thirdtimetrackingentriesListing',
			'timetrackingentriesListing'
		];

		listingNames.forEach(function(listingname){
			if($('#'+listingname+'_container').length > 0){
				Listing.update(listingname);
			}
		});

		MyWindow.close();
	}
};

window.TimetrackingEntryTimer = {
	
	timers		:  {},
	lastSecond	: 0,
	
	createTimer: function(linkedtype, linkedid) {
		var relatedtype = linkedtype	=== undefined ? ''	: linkedtype;
		var relatedid	= linkedid		=== undefined ? 0	: linkedid;
		
		var options = {
			title	: Loc.g("Démarrer un nouveau timer"),
			width	: 600,
			dialogClass : 'dialog-add-timetracking',
			buttons	: [
                {
					text : Loc.g("Fermer"),
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Démarrer le timer"),
                    'class' : 'btn btn-primary',
					click	: function(){
						$('#createTimerForm').submit();
					}
				}
			],
			callback	: function(){
				var options = {
					data	: {
						timer_linkedtype	: linkedtype,
						timer_linkedid		: linkedid,
						action				: 'recordTimerForm'
					},
					success	: function(data) {
						
						var formIsOk = MyForm.processJson(data, "createTimerForm");
						
						if (formIsOk) {
							
							MyWindow.close();
							if($('#supportTimerList').length > 0) {
								var ticketid = $('#overview').attr('ticketid');
								Ticket.timetrackingAutoInitTimersList(ticketid);
							} else {
								Notification.toggleDetail('timetracking', true);
							}
						}
					},
					dataType:"json"
				};
				
				MyForm.prepare("createTimerForm", "timetracking_timer", options);
			}
		};
		
		MyWindow.load("timetracking_timer", {action:"createTimer"}, options);
		const notifDialog = document.querySelector('.notifications-popover');
		
		if(notifDialog) {
			const notifDialogZIndex = window.getComputedStyle(notifDialog).getPropertyValue('z-index')
			document.querySelector('.dialog-add-timetracking').style.zIndex = notifDialogZIndex + 1
			document.querySelector('.ui-widget-overlay').style.zIndex = notifDialogZIndex
		}
	},
	

	startTimer: function(timerid, init){
		var init = init === undefined ? "Y" : init;

		var domTimer = $('.timerTimer[timerid="'+timerid+'"]');

		if (TimetrackingEntryTimer.timers[timerid] !== undefined){
			clearInterval(TimetrackingEntryTimer.timers[timerid]);
		}

		TimetrackingEntryTimer.timers[timerid] = setInterval(function(){
			TimetrackingEntryTimer.hoursCounter(domTimer);
		}, 1000);
		
		$('.timerTimer[timerid="'+timerid+'"]').attr('running', 'Y');
		$('.timerTimer[timerid="'+timerid+'"]').closest('li').find('.fa-pause').show();
		$('.timerTimer[timerid="'+timerid+'"]').closest('li').find('.fa-play').hide();
		
		if (init === 'N'){
			MyFacture.post('timetracking_timer&action=startTimer', {timerid: timerid}, function(data){}, "json");
		}
		
	},
			
	stopTimer: function(timerid){
		if (TimetrackingEntryTimer.timers[timerid] !== undefined){
			clearInterval(TimetrackingEntryTimer.timers[timerid]);
		}
		delete TimetrackingEntryTimer.timers[timerid];
		$('.timerTimer[timerid="'+timerid+'"]').attr('running', 'N');
		$('.timerTimer[timerid="'+timerid+'"]').closest('li').find('.fa-pause').hide();
		$('.timerTimer[timerid="'+timerid+'"]').closest('li').find('.fa-play').show();

		// raz lasttime
		if ($('.timerTimer[timerid="'+timerid+'"]').attr('running') === 'N') {
			$('.timerTimer[timerid="'+timerid+'"]').removeAttr('lasttime');
		}

		MyFacture.post('timetracking_timer&action=stopTimer', {timerid: timerid}, function(data){}, "json");
		
	},
			
	recordTimer: function(timerid){

		TimetrackingEntryTimer.stopTimer(timerid);
		
		var options = {
			title	: Loc.g("Sauvegarder le timer en entrée de Timetracking"),
			width	: 600,
			dialogClass : 'dialog-record-timetracking',
			buttons	: [
                {
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"),
					click	: function(){
						var buttons		= $(this).parent().find('.ui-dialog-buttonpane');
						var register	= buttons.find('button[type=button]').find('span.ui-button-text').first();
						var body		= $('body');

						register.text(Loc.g('Chargement') + ' ...');
						register.attr('disabled', 'disabled');

						if(body.data('addFormDisabled') === undefined) {
							body.data('addFormDisabled', false);
						}

						if(!body.data('addFormDisabled')) {

							body.data('addFormDisabled', true);
							$('#entryForm').submit();

							setTimeout(function() {

								var buttons		= $('#popupWindow').parent().find('.ui-dialog-buttonpane');
								var register	= buttons.find('button[type=button]').find('span.ui-button-text').first();

								register.text(Loc.g('Enregistrer'));
								body.data('addFormDisabled', false);

							}, 2000);

						}
					}
				}
			],
			callback	: function(){
				TimetrackingEntry.prepareForm();
			}
		};
		MyWindow.load("timetracking_entries", {action:"entryForm", timerid : timerid }, options);
		const notifDialogZIndex = Number(document.querySelector('.notifications-popover').style.zIndex)
		if(notifDialogZIndex) {
			document.querySelector('.dialog-record-timetracking').style.zIndex = notifDialogZIndex + 1
		}
	},
		
	deleteTimer: function(timerid){
		
		var options = {
			type	:  "warning",
			dialogClass : 'dialog-delete-timetracking',
			buttons : [
                {
                    text	: Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text	: Loc.g("Supprimer"),
					'class' : 'btn btn-primary',
					click	: function(){
						$(this).dialog("close");
						
						var datas = {action:"deleteTimer", timerid:timerid};
						MyFacture.post(
							"timetracking_timer", 
							{
								action	: "deleteTimer", 
								timerid	: timerid
							},
							function() {
								if(location.href.indexOf('support_ticket') > -1) {
									Ticket.timetrackingAutoInitTimersList($('#overview').attr('ticketid'));
								} else {
									Notification.toggleDetail('timetracking', true);
								}
							}, 
							"json"
						);
					}
				}
			]
		};
		MyWindow.alert(Loc.g("Êtes vous sur de vouloir supprimer ce timer ? Le temps comptabilisé sera perdu."), options);
		const notifDialogZIndex = Number(document.querySelector('.notifications-popover').style.zIndex)
		if(notifDialogZIndex) {
			document.querySelector('.dialog-delete-timetracking').style.zIndex = notifDialogZIndex + 1
		}
	},

	hoursCounter: function(conteneur){		
		
		var lasttime			= conteneur.attr('lasttime');
		
		var time				= parseInt(conteneur.attr('timerunning'), 10);
		var startTime			= time ;
		var tabTemps			=  {
			days		: 86400,
			hours		: 3600,
			minutes		: 60,
			secondes	: 1
			
		};
		var result = "";

		for (var i in tabTemps) {
			var uniteTemps = Math.floor(time / tabTemps[i]);
			time = time % tabTemps[i];
			

			if (uniteTemps > 0 || result.length > 0 || (i == 'secondes' && TimetrackingEntryTimer.lastSecond == 59)) {
				
				if (i == 'secondes') {
					TimetrackingEntryTimer.lastSecond = parseInt(uniteTemps, 10);
				}
				
				conteneur.find('span[class='+i+']').html(uniteTemps) ;
			}
		}
		
		var curenttime			= (new Date()).getTime();

		if(lasttime != undefined) {
			// we calc diff between last call timestamp and timestamp now to get exact time 
			var diff			= Math.round((curenttime - lasttime) / 1000);		
			
			startTime += diff;
		} else {
			startTime += 1;
		}
		
		conteneur.attr('timerunning', startTime);
		conteneur.attr('lasttime', curenttime);
	}
};


window.Timesheet = {
	
	prepareForm: function(){ 
        var formId = "timesheetForm";
		
		$('#timesheetForm input').change(function(){
			$(this).addClass('edited');
		});
		
        var options	= {
			dataType:"json",
			data	: {
				action	: 'record'
			},
			success:function(data){
				Timesheet.recordCallback(data);
			}
		};
		
        MyForm.prepare(formId, "timetracking_timesheet", options);
		
		$.mask.definitions['5']='[0-5]';
		var formatMask = ($('#timesheetForm').attr('data-useprecisionseconde')) ? "99:59:59" : "99:59";
		$(".dayEntry").mask(formatMask, {placeholder:"-", replacement : '0'});
		
		var madate = new Date();
		madate.setMonth(6);
		madate.setDate(23);
		
		$('#timesheet').on('keyup', '.dayEntry', function(){
			Timesheet.computeLine($(this));
			Timesheet.computeCol($(this));
		});
		
		$('#timesheet .dayEntry').trigger('keyup');

		var firstDayOfWeek = madate;
		if(!firstDayOfWeek.is().monday()){
			
			firstDayOfWeek = firstDayOfWeek.previous().monday();
		}
		
		var lastDayOfWeek = madate;
		if(!lastDayOfWeek.is().sunday()){
			lastDayOfWeek = lastDayOfWeek.sunday();
		}
		
		var lang		= $( "#weekPicker" ).attr('lang');
		var format		= $( "#weekPicker" ).attr('format');
		var dateFormat	= "dd/mm/yy";

		switch (format) {
			case 'mdy':
				dateFormat = "mm/dd/yy";
				break;
		}

		$.datepicker.setDefaults($.datepicker.regional[lang]);
		
		$( "#weekPicker" ).datepicker({
            changeMonth: true,
            changeYear: true,
			dateFormat	: dateFormat,
			showOn		: "button",
			buttonText	: "",
			onSelect	: function(date, datePick){
				
				var day		= datePick.currentDay;
				var month	= parseInt(datePick.currentMonth,10)+1;
				var year	= datePick.currentYear;
				
				Timesheet.quit("?_f=timetracking_timesheet&action=timesheetForm&pickDay="+day+"&pickMonth="+month+"&pickYear="+year);
			}
		  }).next(".ui-datepicker-trigger").append("<i class='fa icon-agenda'></i>")
    },
	
	recordCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "timesheetForm");
		
		if(formIsOk){
			Utils.relocate('./?_f=timetracking_timesheet&action=timesheetForm&alertmsg=record&year='+data.year+'&week='+data.week+'&consolidation='+data.consolidation);
		}

	},
	
	computeLine : function(elt){
		
		var totalLine = new Big(0);
		var big60 = new Big(60);

		elt.closest('tr').find('.dayEntry').each(function(){
			var time = $(this).val().replace(new RegExp('-', 'g'), '0');
			var formatTime = (elt.hasClass('hasSeconds')) ? '00:00:00' : '00:00';
			if (time.length !== 0 && time !== formatTime){
				var partTime	= time.split(':');
				
				var hours		= new Big(partTime[0]);
				hours			= hours.times(big60*big60);
				
				var mins		= new Big(partTime[1]);
				mins			= mins.times(big60);

				totalLine		= totalLine.plus(hours).plus(mins);
				
				if (elt.hasClass('hasSeconds')) {
					var seconds = new Big(partTime[2]);
					totalLine	= totalLine.plus(seconds);
				}
			}
		});

		var totalLineHours		= Math.floor(totalLine.div(big60 * big60));
		totalLineHours			= totalLineHours <= 9 ? '0'+totalLineHours : totalLineHours;
		var totalLineMinutes	= Math.floor((totalLine.div(big60)) % big60);
		totalLineMinutes		= totalLineMinutes <= 9 ? '0'+totalLineMinutes : totalLineMinutes;
		
		if (elt.hasClass('hasSeconds')) {
			var totalLineSeconds	= totalLine % big60;
			totalLineSeconds		= totalLineSeconds <= 9 ? '0'+totalLineSeconds : totalLineSeconds;
		}

		var totalTime = (undefined !== totalLineSeconds) ? totalLineHours+':'+totalLineMinutes+':'+totalLineSeconds : totalLineHours+':'+totalLineMinutes;

		elt.closest('tr').find('.totalLine').html(totalTime);
	},
	
	computeCol : function(elt) {
		// Parcours en colonnes
		var totalCol	= new Big(0);
		var big60		= new Big(60);
		
		var classes		= elt.attr('class');
		var regexp		= (elt.hasClass('hasSeconds')) ? 'dayEntry hasSeconds ' : 'dayEntry ';

		var class2run	= classes.replace(new RegExp(regexp, 'g'), '');
		
		$('.'+class2run, '#timesheet').each(function(){
			var time		= $(this).val().replace(new RegExp('-', 'g'), '0');
			var formatTime	= (elt.hasClass('hasSeconds')) ? '00:00:00' : '00:00';
			
			if(time.length !== 0 && time !== formatTime){
				var partTime	= time.split(':');
				
				var hours		= new Big(partTime[0]);
				hours			= hours.times(big60*big60);

				var mins		= new Big(partTime[1]);
				mins			= mins.times(big60);

				totalCol		= totalCol.plus(hours).plus(mins);
				
				if (elt.hasClass('hasSeconds')) {
					var seconds = new Big(partTime[2]);
					totalCol	= totalCol.plus(seconds);
				}
			}
		});
		
		var totalColHours	= Math.floor(totalCol.div(big60 * big60));
		totalColHours		= totalColHours <= 9 ? '0'+totalColHours : totalColHours;
		var totalColMinutes	= Math.floor((totalCol.div(big60)) % big60);
		totalColMinutes		= totalColMinutes <= 9 ? '0'+totalColMinutes : totalColMinutes;
		var totalTime		= totalColHours.toString()+':'+totalColMinutes.toString();

		if (elt.hasClass('hasSeconds')) {
			var totalColSeconds = totalCol % big60;
			totalColSeconds		= totalColSeconds <= 9 ? '0'+totalColSeconds : totalColSeconds;
			totalTime			+= ':'+totalColSeconds.toString();
		}

		$('#total'+class2run).html(totalTime);
	},
	
	newLine : function(){
		
		var options = {
			title	: Loc.g("Ajouter une nouvelle ligne"),
			width	: 600,
			buttons	: [
                {
					text : Loc.g("Fermer"), 
					click : function(){$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Ajouter la ligne"), 
					click : function(){
						$('#timesheetFormNewLine').submit();
					}
				}
			],
			callback	: function(){
                Timesheet.prepareNewLineForm();
			}
		};
		
		var nbLines = $('#timesheet .line').length;
		MyWindow.load("timetracking_timesheet", {action:"newLineForm", position:nbLines }, options);
		
	},
			
	prepareNewLineForm: function(){

		var options = {
			data	: {
				action : "recordNewLineForm"
			},
			success:function(data){
				Timesheet.recordNewLineForm(data);
			}, 
			dataType:"json"
		};
		
        MyForm.prepare("timesheetFormNewLine", "timetracking_timesheet", options);

		TokenInput.autoItem("#entry_serviceid", 'service', 'timetrackingEnabled', 1, true, '');
		
		TokenInput.autoContactListing("#entry_thirdid", 'third|prospect', 1, true, '', 
			// ADD
			function(item){ 
				var more = item.id.replace(new RegExp('corporation_', 'g'), 'third_');
				if ($("#entry_linked").length > 0){
					$("#entry_linked").tokenInput('more', more);
				}
				$("#entry_ttLinkedElementlinked").tokenInput('more', more);
			},
			// DELETE
			function(){
				if ($("#entry_linked").length > 0) {
					$("#entry_linked").tokenInput('clear');
					$("#entry_linked").tokenInput('more', '');
				}

				$("#entry_ttLinkedElementlinked").tokenInput('clear');
				$("#entry_ttLinkedElementlinked").tokenInput('more', '');
			}
		);

		var autodoc = $("#entry_linked").data('autodoc');
		TokenInput.autoDocumentListing("#entry_linked", autodoc, 1, true, '', 
			function(item){
				var third = $("#entry_thirdid");
				if(third.tokenInput('get').length === 0) {
					$("#entry_thirdid").tokenInput('add', {id : item.thirdid, name: item.thirdname});
				}
		}, '', 'timetracking');

		TimetrackingEntry.initEntryFormTokeninputs();

		$('#entry_ttLinkedElementlinkedType').change(function(){
			$('#entry_ttLinkedElementlinked').parent().find(".token-input-list").remove();
			$("#entry_ttLinkedElementlinked").tokenInput('clear');
			TimetrackingEntry.initEntryFormTokeninputs();
        });
        
        var autoTag = $('#entry_tags');
        TokenInput.autoTag(autoTag, $(autoTag).attr('e_autotag'));
		
	},
			
	recordNewLineForm: function(data){

		var formIsOk = MyForm.processJson(data, "timesheetFormNewLine");
		
		if (formIsOk){
			
			var existingLine = $(".hash[value='"+data.line.hash+"']").closest('tr');
			
			if(existingLine.length > 0 && existingLine.find('.deleted').val() === 'N'){
				
				MyWindow.alert(Loc.g('Cette ligne existe déjà dans la feuille de temps'), {type: 'error'});
			} else if (existingLine.length > 0 && existingLine.find('.deleted').val() === 'Y'){
				existingLine.find('.deleted').val('N');
				existingLine.show();
			} else {
				var htmlRow			= data.timesheetRow;
				$('#timesheet tbody').append(htmlRow);
				
				$.mask.definitions['5']='[0-5]';
				var formatMask = ($('#timesheetForm').attr('data-useprecisionseconde')) ? "99:59:59" : "99:59";
				$(".dayEntry").mask(formatMask,{placeholder:"-", replacement : '0'});
			}
			
			$('#noLines').hide();
			
			MyWindow.close();
		}

	},
	
	quit : function(url){
		
		var nbEdited = $('.edited').length;
		var nbNew = $('input[id^="linenew"]').length;
		
		if (nbEdited > 0 || nbNew > 0){
			var options = {
				resizable	: false,
				noclose		: true,
				title		: Loc.g("Attention!"),
				type		: "warning",
				buttons		: [
					{
						text : Loc.g("Non"), 
						click : function(){
							$(this).dialog("close");
							return false;
						}
					},
					{
						text : Loc.g("Oui"), 
						click : function(){
							Utils.relocate(url);
						}
					}
				]
			};
			MyWindow.alert(Loc.g("Les modifications effectuées seront perdues. Continuer?"), options);
		} else {
			Utils.relocate(url);
		}
		
	},
	
	showAlertMessage: function(message){
		MyWindow.alert(message, {type:'confirm'});
	},
	
	deleteLine : function(lineId){
		
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		:  [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"),
					click : function(){

						$('#'+lineId).find('.deleted').val('Y');
						$('#'+lineId).hide();

						$('.dayEntry').trigger('keyup');
						if($('#timesheet tbody .line:visible').length <= 0){
							$('#noLines').show();
						}
						$(this).dialog("close");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Les heures saisies sur cette ligne seront effacées au prochain enregistrement. Continuer? <br /> Les entrées consolidées, non modifiables ne seront pas supprimées"), options);
		
	},
	
	addNote : function(textareaID){
		
		var note = $('#'+textareaID).val();
		
		var options = {
			width		: 600,
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Note"),
			open		: function(){
				MyFacture.customForm();
			},
			buttons		:  [
                {
					'class' : 'btn btn-default',
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					'class' : 'btn btn-primary',
					text : Loc.g("Enregistrer"), 
					click : function(){
						var newNote = $('#popupForm').val();
						$('#'+textareaID).val(newNote);
						$(this).dialog("close");
					}
				}
			]
		};
		
		MyWindow.alert('<textarea style="width:100%;height:100px;" class="redactor" id="popupForm">'+_.escape(note)+'</textarea>', options);
	},
	
	viewEntriesFromIds: function(stringIds){
		
		var options = {
			title	: Loc.g("Liste des entrées"),
			width	: 600,
			buttons	: [
				{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			callback	: function(){}
		};
		
		MyWindow.load("timetracking_entries", {action:"viewEntriesFromIds", stringIds:stringIds}, options);
		
	},
	
	buildWithPreviousWeek : function(week, year){
		
		MyFacture.post(
			'timetracking_timesheet', 
			{
				action	: 'buildWithPreviousWeek', 
				week	: week, 
				year	: year
			}, 
			function(data){
				
				if(data.lines !== ''){
					
					$('#timesheet tbody').append(data.lines);
					$.mask.definitions['5']	= '[0-5]';
					var formatMask			= ($('.dayEntry').hasClass('hasSeconds')) ? "99:59:59" : "99:59";
					
					$(".dayEntry").mask(formatMask,{placeholder:"-", replacement : '0'});
					$('#noLines').hide();
					
				}else{
					MyWindow.alert(Loc.g('La semaine précédente ne comporte aucune heure.'), {type : 'warning'});
				}
			}, 
			'json');
	}
	
};

window.TimetrackingTools = {
	
	mandayToMin: function(manDay, nbMinADay){
		return Math.round((manDay * (nbMinADay*60)) * 100) / 100;
	},
	
	minToManDay : function(min, nbMinADay){
		return Math.round((min / (nbMinADay*60)) * 100) / 100;
		
	},
	
	hourMinSecToSec : function(hourMin){
		var parts = hourMin.split(':');
		var nbSec = 0;
		if (parts.length === 2) {
			nbSec = parseInt(parts[0], 10) * (60*60) + parseInt(parts[1], 10) * 60;
		}
		if (parts.length === 3) {
			nbSec = parseInt(parts[0], 10) * (60*60) + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
		}

		return nbSec;
	},
			
	secToHourMinSec: function(secs){
		var unit	= 60;

		var hours	= Math.floor(secs / (unit*unit));
		var mins	= Math.floor((secs / unit) % unit);
		var secs	= (secs % unit);
		
		return [
			hours, 
			mins, 
			secs
		];
	},

	formatTimeToString: function(hourMinArray, usePrecisionSecond) {
		if (usePrecisionSecond) {
			return TimetrackingTools.str_pad(hourMinArray[0], 2, '0', 'STR_PAD_LEFT')+':'+TimetrackingTools.str_pad(hourMinArray[1], 2, '0', 'STR_PAD_LEFT')+':'+TimetrackingTools.str_pad(hourMinArray[2], 2, '0', 'STR_PAD_LEFT');
		} else {
			return TimetrackingTools.str_pad(hourMinArray[0], 2, '0', 'STR_PAD_LEFT')+':'+TimetrackingTools.str_pad(hourMinArray[1], 2, '0', 'STR_PAD_LEFT');
		}
	},

	str_pad: function(input, pad_length, pad_string, pad_type) {

		var half = '', pad_to_go;

		var str_pad_repeater = function(s, len) {
			
			var collect = '', i;
			while (collect.length < len) {
				collect += s;
			}
			collect = collect.substr(0, len);

			return collect;
		};

		input += '';
		pad_string = pad_string !== undefined ? pad_string : ' ';

		if (pad_type !== 'STR_PAD_LEFT' && pad_type !== 'STR_PAD_RIGHT' && pad_type !== 'STR_PAD_BOTH') {
			pad_type = 'STR_PAD_RIGHT';
		}
		
		if ((pad_to_go = pad_length - input.length) > 0) {
			if (pad_type === 'STR_PAD_LEFT') {
				input = str_pad_repeater(pad_string, pad_to_go) + input;
			} else if (pad_type === 'STR_PAD_RIGHT') {
				input = input + str_pad_repeater(pad_string, pad_to_go);
			} else if (pad_type === 'STR_PAD_BOTH') {
				half = str_pad_repeater(pad_string, Math.ceil(pad_to_go / 2));
				input = half + input + half;
				input = input.substr(0, pad_length);
			}
		}
		return input;
	}
};